<template>
  <div>

    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <div class="float-right BankaSecim EkspresBorclandirma" v-if="BorclandirmaVeri">
        <el-select v-model="Form.Borclandirma_id" size="small" @change="BorclandirmaSablonu()"
                   placeholder="Ekspres Borçlandırma"
                   filterable
                   clearable>
          <el-option
            v-for="b in BorclandirmaVeri"
            :key="b.id"
            :label="b.Bina+' - '+b.Tanim"
            :value="b.id">
            <span style="float: left">{{ b.Tanim }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ b.Bina }}</span>
          </el-option>
        </el-select>

      </div>
      <el-button-group class="float-right YeniBtn">
        <el-button v-if="Yetki" type="success" size="small" class="YeniBtn" @click="this.Submit"
                   icon="el-icon-check">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :rules="FormHata" :model="Form"
               @submit.prevent.native="Submit"
               ref="GiderForm">
        <el-row :gutter="24" v-if="Form.Borclandirma_id">
          <el-col :span="24">
            <el-alert
              effect="dark"
              :title="SeciliBorc.Bina+' Ekspres Borçlandırma Verisi'"
              close-text="Borçlandırmayı Sil"
              @close="EkspresIptal(Form.Borclandirma_id)"
              description="Lütfen gerekli seçimleri yapıp, borçlandırma önizlemesi ile borçlandırmayı onaylayınız."
              type="info">
            </el-alert>

            <hr>
          </el-col>

        </el-row>
        <el-row :gutter="24">


          <el-col :span="8" v-if="!Form.Borclandirma_id">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select @change="BinaSecimi()" v-model="Form.Bina_id" filterable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="BinaBazli">
            <el-form-item class="Tooltip" label="Mesken Bazlı" prop="MeskenBazli">
              <el-tooltip class="item" effect="dark"
                          content="Belirli meskenleri seçip borçlandırmak için aktif ediniz."
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="Form.MeskenBazli"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="Form.MeskenBazli">
            <el-form-item label="Meskenler" prop="Meskenler">
              <el-cascader
                :options="MeskenListe"
                v-model="Form.Meskenler"
                collapse-tags
                :props="{ multiple: true }"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Kategori" prop="Kategori_id">
              <el-cascader
                collapse-tags
                :options="Kategoriler"
                v-model="Form.Kategori_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :span="4" v-if="!Form.Borclandirma_id">
            <el-form-item :label="TutarContent" prop="Tutar">
              <el-input v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item class="Tooltip" label="Zam Oran" prop="zOran">
              <el-tooltip class="item" effect="dark"
                          content="Gecikme durumunda uygulanacak zam oranı"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-input prefix-icon="el-icon-coin" v-model="Form.zOran"/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Borçlanma Tarihi" prop="tTarihi">
              <el-date-picker
                v-model="Form.tTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Son Ödeme Tarihi" prop="sTarihi">
              <el-date-picker
                v-model="Form.sTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse>
          <el-collapse-item title="Spesiyal Özellikler" name="1">
            <el-row :gutter="24">

              <el-col :span="2" v-if="TekrarDisplay && !Form.Sayac && !Form.Borclandirma_id">
                <el-form-item label="Tekrarla" prop="Tekrar">
                  <el-switch v-model="Form.Tekrar"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="!Form.Tekrar">
                <el-form-item class="Tooltip" label="Sms" prop="Sms">
                  <el-tooltip class="item" effect="dark"
                              content="Borçlandırmayı SMS olarak bildir"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.Sms"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item class="Tooltip" label="Sanal Pos" prop="oOdeme">
                  <el-tooltip class="item" effect="dark"
                              content="Borçlandırma Online işlemlerden ödenebilsin"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.oOdeme"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="$store.getters.Paket==1">
                <el-form-item class="Tooltip" label="Zam Şirketin" prop="zSirket">
                  <el-tooltip class="item" effect="dark"
                              content="Tahsil edilen gecikme zammı şirkete gelir olarak işlenir"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.zSirket"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="!Form.Tekrar && !Form.Sayac && !Form.Borclandirma_id">
                <el-form-item class="Tooltip" label="Parçala" prop="Dagit">
                  <el-tooltip class="item" effect="dark"
                              content="Yazılan tutar bütün meskenlere eşit şekilde bölünecektir"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.Dagit"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="!Form.ManuelSayac && !Form.Borclandirma_id">
                <el-form-item class="Tooltip" label="M2" prop="m2">
                  <el-tooltip class="item" effect="dark"
                              :content="m2Content"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.m2"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="Form.Tekrar">
              <hr>
              <el-row :gutter="24">
                <el-col :span="3">
                  <el-form-item label="Tekrar Sayısı" prop="TekrarSayisi">
                    <el-input-number v-model="Form.TekrarSayisi" :precision="0" :step="1" :min="2"
                                     :max="24"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="Gün Döngüsü" prop="GunDongusu">
                    <el-input-number v-model="Form.GunDongusu" :precision="0" :step="1" :min="2"
                                     :max="28"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="Tekrar Adı" prop="TaksitAdi">
                    <el-switch v-model="Form.TaksitAdi"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item label="Ay Adı" prop="AyAdi">
                    <el-switch v-model="Form.AyAdi"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="!Form.Dagit && !Form.Tekrar && !Form.Borclandirma_id" title="Sayaç Borçlandırma"
                            name="2">
            <el-row :gutter="24">
              <el-col :span="2">
                <el-form-item class="Tooltip" label="Sayaç Çalıştır" prop="Sayac">
                  <el-tooltip class="item" effect="dark" s
                              content="Borçlandırma eğer bir sayaç borçlandırmasıysa açınız"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.Sayac"></el-switch>
                </el-form-item>
              </el-col>

              <el-col :span="2" v-if="Form.Sayac">
                <el-form-item class="Tooltip" label="Endeks" prop="Manuel">
                  <el-tooltip class="item" effect="dark"
                              content="Okunan endeksler faturaya bölünme değil birim ile çarpılacaksa açınız"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-switch v-model="Form.ManuelSayac"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="4" v-if="Form.Sayac">
                <el-form-item label="Okuma Tarihi" prop="oTarihi">
                  <el-date-picker
                    v-model="Form.oTarihi"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3" v-if="!Form.ManuelSayac && Form.Sayac">
                <el-form-item class="Tooltip" label="Ortak Oran" prop="SayacOrtak">
                  <el-tooltip class="item" effect="dark"
                              content="Fatura tutarından ortak olarak dağıtılacak oran"
                              placement="top">
                    <i class="el-icon-info text-primary cursor-pointer"></i>
                  </el-tooltip>
                  <el-input suffix-icon="el-icon-pie-chart" v-model="Form.SayacOrtak"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>

    <el-dialog
      title="Borçlandırma Önizlemesi"
      :visible.sync="Modal"
      width="90%">
      <a @click="Modal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Borclandirma v-if="FormTipi=='Tek' && OnayData" @Onay="Sifirla" :Bilgi="Bilgi" :data="OnayData"></Borclandirma>
      <Taksitli v-if="FormTipi=='Taksit' && OnayData" @Onay="Sifirla" :Bilgi="Bilgi" :data="OnayData"></Taksitli>
      <Sayac v-if="FormTipi=='Sayac' && OnayData" @Onay="Sifirla" :Bilgi="Bilgi" :data="OnayData"></Sayac>
    </el-dialog>


  </div>
</template>

<script>
import Borclandirma from "../../../components/Pack/Muhasebe/tahakkuk/Borclandirma";
import Taksitli from "../../../components/Pack/Muhasebe/tahakkuk/Taksitli";
import Sayac from "../../../components/Pack/Muhasebe/tahakkuk/sayac";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, Sayac, Taksitli, Borclandirma},
  data() {
    return {
      Yetki: false,

      lo: false,
      Kaydet: true,
      Modal: false,
      OnayData: null,
      TableClass: null,
      Sayfa: {
        ButtonAdi: 'Borçlandırma Önizleme',
        Adi: 'Mesken Borçlandır',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Arama: this.$t('eGenel.9'),
        Menu: [
          {Adi: 'Excel Yükle', Link: '/muhasebe/tahakkuk/excel'},
        ],
        MenuDisplay: true,

      },
      m2Content: 'Tutar daire metrekaresi ile çarpılarak borçlandırılır',
      Oldm2Content: null,
      TutarContent: 'Tutar',
      Form: {
        Borclandirma_id: null,
        Bina_id: null,
        Kategori_id: null,
        sTarihi: null,
        tTarihi: null,
        oTarihi: false,
        Tutar: 0,
        Aciklama: null,
        Tekrar: false,
        zSirket: false,
        zOran: 0,
        oOdeme: true,
        Sms: false,
        Dagit: false,
        m2: false,
        TekrarSayisi: 2,
        GunDongusu: 2,
        MeskenBazli: false,
        TaksitAdi: null,
        AyAdi: false,
        AnaPara: false,
        Sayac: false,
        ManuelSayac: false,
        SayacOrtak: 0,
        Taksitler: [],
        Meskenler: [],
      },
      FormHata: {
        Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        tTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        sTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Meskenler: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      BinaBazli: false,
      Binalar: [],
      Siteler: [],
      Daireler: [],
      MeskenListe: [],
      Kategoriler: [],
      AltToplam: null,
      SecilenBilgi: {},
      Meskenler: [],
      TekrarDisplay: true,
      FormTipi: null,
      Onay: false,
      SeciliBorc: null,
      BorclandirmaVeri: null,
    }
  },
  methods: {
    EkspresIptal(id) {
      this.$store.dispatch("Delete", {path: 'muhasebe/apiborc/' + id})
        .then(response => {
          this.lo = false
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.Form.Borclandirma_id = null;
            this.BorclandimaVeriGetir()
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    BorclandimaVeriGetir(){
      this.$store.dispatch("Get", {path: 'muhasebe/apiborc'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.BorclandirmaVeri = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    BorclandirmaSablonu() {
      this.SeciliBorc = this.BorclandirmaVeri.filter(c => c.id.includes(this.Form.Borclandirma_id))[0];
      this.Form.Aciklama = this.SeciliBorc.Tanim
    },
    Submit() {
      this.$refs['GiderForm'].validate((valid) => {
        if (valid) {
          this.lo = true
          if (this.Form.Tekrar) this.Form.Taksitler = this.Taksitler; else this.Form.Taksitler = null;
          if (!this.Form.MeskenBazli) this.Form.Meskenler = null;
          this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/tahakkuk/tahakkuk/onizleme'})
            .then(response => {
              if (response.Durum == "OK") {
                this.Modal = true;
                this.OnayData = response.Data;
                this.Bilgi = response.Bilgi;
                this.FormTipi = response.FormTipi
                this.lo = false
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
                this.lo = false
              }
            })
        }
      })
    },
    Sifirla() {
      var Gun = new Date();
      var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      this.m2Content = 'Tutar daire metrekaresi ile çarpılarak borçlandırılır';
      this.Modal = false;
      this.Form = {
        Bina_id: null,
        Kategori_id: null,
        sTarihi: AySonu,
        tTarihi: Gun,
        oTarihi: Gun,
        Tutar: 0,
        Aciklama: null,
        Tekrar: false,
        zSirket: false,
        zOran: 0,
        oOdeme: true,
        Sms: false,
        Dagit: false,
        m2: false,
        TekrarSayisi: 2,
        GunDongusu: 2,
        MeskenBazli: false,
        TaksitAdi: null,
        AyAdi: false,
        Sayac: false,
        ManuelSayac: false,
        SayacOrtak: 0
      };
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
        this.BinaSecimi()
      }
    },
    BinaSecimi() {
      this.Form.MeskenBazli = false;
      const SecilenBilgi = this.Binalar.filter(c => c.id.includes(this.Form.Bina_id))[0];
      this.BinaBazli = SecilenBilgi == null ? false : true;
      this.MeskenGetir();
    },
    MeskenGetir() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/mesken/' + this.Form.Bina_id + '/K'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.MeskenListe = response.Liste
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
            this.lo = false;
          }
        });
    },

    SayfaYukle() {
      this.BorclandimaVeriGetir()
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kategoriler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      this.$store.dispatch("Get", {path: 'yonetim/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/site'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
    this.$store.commit("SayfaBilgi", this.Sayfa);
    this.SayfaYukle();
    //+'.'+Gun.getMonth()+'.'+Gun.getFullYear()
    var Gun = new Date();
    var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.tTarihi = Gun;
    this.Form.oTarihi = Gun;
    this.Form.sTarihi = AySonu;
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      this.BinaBazli = true;
      //this.BinaSecimi();
    }
  },
  computed: {
    Tutar() {
      return this.Form.Tutar
    },
    Tekrar() {
      return this.Form.Tekrar
    },
    MeskenBazli() {
      return this.Form.MeskenBazli
    },
    Dagit() {
      return this.Form.Dagit
    },
    Sayac() {
      return this.Form.Sayac
    },
    ManuelSayac() {
      return this.Form.ManuelSayac
    }
  },
  watch: {
    Tutar() {
      if (this.Form.Tutar) this.Form.Tutar = this.Form.Tutar.replace(",", ".");
      //console.log(this.Form.Tutar);
    },
    Tekrar() {
      if (this.Form.Tekrar) {
        this.Kaydet = false;
        this.Form.Sms = false;
      } else {
        this.Kaydet = true
      }
      //console.log(this.Form.Tutar);
    },
    Dagit() {
      if (this.Form.Dagit) {
        this.m2Content = "Yazılan tutar metrekareye göre meskenlere bölüştürülür";
        this.Form.Tekrar = false;
        this.TekrarDisplay = false
      } else {
        this.m2Content = "Tutar daire metrekaresi ile çarpılarak borçlandırılır";
        this.TekrarDisplay = true
      }
      //console.log(this.Form.Tutar);
    },
    Sayac() {
      if (this.Form.Sayac) {
        this.Sayfa.Adi = "Sayaç Borçlandırma";
        this.TutarContent = "Fatura Tutarı";
        this.Sayfa.ButtonAdi = "Sayaç Endeks Gir";
        this.Oldm2Content = this.m2Content;
        this.m2Content = "Ortak alan m2 göre paylaştırılır";
      } else {
        this.Sayfa.Adi = "Mesken Borçlandırma";
        this.TutarContent = "Tutar";
        this.Sayfa.ButtonAdi = "Borçlandırma Önizleme";
        this.m2Content = this.Oldm2Content
      }
    },
    ManuelSayac() {
      if (this.Form.ManuelSayac) {
        this.TutarContent = "Endeks Birim Fiyatı";
      } else {
        this.TutarContent = "Fatura Tutarı"
      }
    },
    MeskenBazli() {
      if (this.Form.MeskenBazli) {
        this.MeskenGetir();
      } else {
        this.Form.Meskenler = [];
        this.Meskenler = []
      }
    }
  }
}
</script>

<style>
.BankaSecim {
  display: inline-block;
  position: relative;
  top: -3px;
  right: 175px;
  width: 350px;
}

</style>




// WEBPACK FOOTER //
// src/pages/Muhasebe/tahakkuk/tahakkuk.vue